import { Environment } from '@abp/ng.core';

const baseUrl = 'https://portal-qa.sgu.edu';

const oAuthConfig = {
  issuer: 'https://portal-qa.sgu.edu/',
  redirectUri: baseUrl,
  clientId: 'SelfServePortal_App',
  responseType: 'code',
  scope: 'offline_access SelfServePortal',
  requireHttps: true,
  impersonation: {
    userImpersonation: true,
    tenantImpersonation: true,
  },
};

export const environment = {
  production: false,
  mappedTaxonomies: {
    clinicalStudyId: '918',
  },
  mapbox: {
    accessToken: 'pk.eyJ1IjoidXNzbWFyY29tIiwiYSI6ImNta3lodnM4eDA3NW4zZXB0M2pjbWxtN2EifQ.tBTsyNnaPcBmMxh6h-s1ng',
  },
  application: {
    baseUrl,
    name: 'SelfServePortal',
  },
  oAuthConfig,
  apis: {
    default: {
      url: '',  // <- should be empty string, not '/' because we are serving SPA from API application.  See https://abp.io/docs/latest/framework/infrastructure/csrf-anti-forgery#angular-ui
      rootNamespace: 'SelfServePortal',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
  },
} as Environment & {
  mappedTaxonomies: {
    clinicalStudyId: string;
  };
  mapbox: {
    accessToken: string;
  };
};
